module.exports = __webpack_public_path__ + "static/psc-sandiego-f69953aec8d0aeaba57ad1bbd03fb86e.png";